import React, { useState } from 'react';
import { Route, Redirect } from 'react-router';
import { getVerifiedToken } from '#utils/authService';
import { useEffect } from 'react';

const PrivateRoute = ({ component: Component, ...rest }) => {
	const [access, setAccess] = useState(undefined);
	const usersAllow = process.env.REACT_APP_METRICS_USERS;
	useEffect(() => {
		async function checkToken() {
			const verified = await getVerifiedToken();
			if (verified) {
				setAccess(verified.decoded);
			} else {
				setAccess(null);
			}
		}
		checkToken();
	}, []);

	if (access === undefined) {
		return <></>;
	} else if (access == null || (access && !usersAllow.includes(+access.usuario.Id_Usuario))) {
		return <Redirect to="/" />;
	} else if (access) {
		return <Route {...rest} component={Component} />;
	}
};
export default PrivateRoute;
